import { createContext } from 'react';

export const NetworkContext = createContext(null);
